import { T } from '@/lib/theme'

// The row chrome the Vaults page's tables are built from, in one place so the CLM pair tables and
// the single-asset staking table cannot drift apart.
//
// Extracted rather than copied: these three objects were local to VaultsSection.jsx, and the
// staking panel needed to match them exactly. Duplicating four numbers is the kind of thing that
// stays right until someone adjusts one padding value, at which point two tables on the SAME page
// disagree by 2px and nobody can see why. Importing from VaultsSection directly would have created
// a cycle, since VaultsSection imports the staking panel.

export const headerRow = {
  display: 'flex', alignItems: 'center', gap: 12,
  padding: '14px 20px', borderBottom: `1px solid ${T.border}`,
  background: 'rgba(255,255,255,0.02)',
}

export const headCell = {
  color: T.textDim, fontFamily: T.fontM, fontSize: T.fs.caption, fontWeight: 700,
  letterSpacing: '0.06em', textTransform: 'uppercase', userSelect: 'none',
}

export const row = {
  display: 'flex', alignItems: 'center', gap: 12,
  padding: '16px 20px', borderBottom: `1px solid ${T.border}`,
}
